<script>
	import { onMount } from 'svelte'
	import { fade, fly } from 'svelte/transition'

	export let loginLinks = jQuery('.client-login > a')

	const { ajaxUrl, loadingMessage, lostPassUrl } = window.login_form_object

	let securityToken = false
	let shown = false
	let username = ''
	let email = ''
	let firstName = ''
	let lastName = ''
	let password = ''
	let status = false
	let disabledForm = false
	let redirectUrl = '/my-account/'
	let register = false

	const { logoSrc } = window.modal_object

	// refs
	let usernameField
	let firstNameField

	const showModal = () => {
		shown = true
		// focus on username
		setTimeout(() => usernameField.focus(), 20)
		// get security token
		if (!securityToken) {
			jQuery.get('/wp-json/ctel-api/v1/get-token').done(function(res) {
				if (res) {
					securityToken = jQuery(res).val()
				}
			})
		}
	}
	const hideModal = () => (shown = false)

	const switchState = newState => {
		status = ''
		register = newState
		setTimeout(() => (newState ? firstNameField : usernameField).focus(), 20)
	}

	const formSubmit = e => {
		if (disabledForm) {
			return
		}
		e.preventDefault()
		if (!securityToken) {
			status = 'Error checking credentials. Redirecting to login page...'
			setTimeout(() => {
				window.location.href = '/wp-login.php'
			}, 999)
			return
		}
		// disable submit for 1 second
		disabledForm = true
		setTimeout(() => {
			disabledForm = false
		}, 999)
		status = loadingMessage
		let action = register ? 'ajaxregister' : 'ajaxlogin'
		let data = {
			action,
			username,
			password,
			firstName,
			lastName,
			email,
			security: securityToken,
		}
		jQuery.ajax({
			type: 'POST',
			dataType: 'json',
			url: ajaxUrl,
			data,
			success: data => {
				status = data.message
				if (data.loggedin === true) {
					window.location.href = redirectUrl
					// if (data.redirect_url) {
					// 	// window.location.href = window.location.href
					// } else {
					// 	window.location.reload()
					// }
				}
			},
			error: data => {
				status = 'Error checking credentials. Redirecting to login page...'
				setTimeout(() => {
					window.location.href = '/wp-login.php'
				}, 999)
				return
			},
		})
	}

	const closePopup = () => {
		// html.classList.remove('show-modal')
		shown = false
	}
	const wrapClick = e => e.target === e.currentTarget && closePopup()

	onMount(() => {
		loginLinks.on('click', function(e) {
			e.preventDefault()
			if (this.href) {
				redirectUrl = this.href
			}
			showModal()
		})
		// modal hide on escape press
		document.body.addEventListener('keyup', function(e) {
			if (e.keyCode === 27) {
				hideModal()
			}
		})
	})
</script>

<svelte:window on:keyup={e => e.keyCode === 27 && closePopup()} />

{#if shown}
	<div
		class="login-modal team-popup-wrap"
		on:click={wrapClick}
		transition:fade={{ duration: 300 }}>
		<div class="main" on:click={wrapClick}>
			<div class="inner-wrap" in:fly={{ y: 15 }} out:fly={{ y: -15 }}>
				<div class="team-popup">

					<div class="modal-head">
						<img src={logoSrc} alt="Christel Construction" />
					</div>
					<div class="modal-body">
						<form
							id="login"
							action="login"
							method="post"
							on:submit={formSubmit}>
							{#if status}
								<p class="status">{status}</p>
							{/if}
							<div class="form-input-wrap">
								<label class="sr-only" for="username">Username or Email</label>
								<input
									id="username"
									type="text"
									name="username"
									bind:this={usernameField}
									bind:value={username}
									placeholder="Username or Email..."
									autocomplete="username"
									required />
							</div>
							<div class="form-input-wrap password-wrap">
								<label class="sr-only" for="password">Password</label>
								<input
									id="password"
									type="password"
									name="password"
									bind:value={password}
									placeholder="Password..."
									required
									autocomplete="current-password" />
							</div>
							<div class="form-submit-wrap">
								<input
									type="submit"
									name=""
									value={`${register ? 'Register' : 'Login'}`}
									class="btn"
									disabled={disabledForm} />
							</div>
						</form>
						{#if !register}
							<p class="having-trouble">
								Having trouble logging in?
								<a href={lostPassUrl}>
									<i>Reset your password.</i>
								</a>
							</p>
						{/if}
					</div>

				</div>
				<button class="close-popup" on:click={closePopup}>
					<span>&times;</span>
				</button>
			</div>
		</div>
	</div>
{/if}
